import { ActivateTransactionFragment } from '@occc/graphql';
import { TransactionViewFinalizeRequestHeader } from '@occc-app/routes/Transactions/TransactionView/TransactionViewFinalizeRequestHeader';
import { TransactionViewFinalizeRequestBody } from '@occc-app/routes/Transactions/TransactionView/TransactionViewFinalizeRequestBody';
import { useMemo } from 'react';
import { getTransactionViewFinalizeRequestData } from '@occc-app/routes/Transactions/TransactionView/utils';

const TransactionViewFinalizeRequest = ({
  transaction,
}: {
  transaction: ActivateTransactionFragment;
}) => {
  const [data, jsonObject] = useMemo(() => {
    // some transactions have JSON string payload
    if (typeof transaction.payload === 'string') {
      try {
        const json = JSON.parse(transaction.payload);
        return [getTransactionViewFinalizeRequestData({ ...transaction, payload: json }), json];
      } catch {
        return [{}, transaction.payload];
      }
    }
    return [getTransactionViewFinalizeRequestData(transaction), transaction.payload];
  }, [transaction]);

  return (
    <>
      <TransactionViewFinalizeRequestHeader {...data} />
      <TransactionViewFinalizeRequestBody payload={jsonObject} />
    </>
  );
};

export default TransactionViewFinalizeRequest;
